import React from "react";
import { cn } from "@/lib/utils";

interface SectionCardProps {
  title: string;
  /** Optional one-line explanation under the title. */
  description?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  /** Drop the body padding, for tables and lists that run edge to edge. */
  noPadding?: boolean;
  className?: string;
  bodyClassName?: string;
}

/** The standard titled panel: soft white card, header row, body. */
export default function SectionCard({
  title,
  description,
  children,
  actions,
  noPadding = false,
  className,
  bodyClassName,
}: SectionCardProps) {
  return (
    <section
      className={cn(
        "flex h-full min-w-0 flex-col overflow-hidden rounded-xl border border-border bg-card text-card-foreground shadow-soft",
        className,
      )}
    >
      <div className="flex min-h-16 flex-wrap items-center justify-between gap-3 border-b border-border px-5 py-3.5 md:px-6">
        <div className="min-w-0">
          <h2 className="text-base leading-6 font-medium tracking-[-0.2px] text-foreground">
            {title}
          </h2>
          {description && <p className="text-caption text-muted-foreground">{description}</p>}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2 max-sm:w-full max-sm:[&>*:not([data-slot=badge])]:flex-1">
            {actions}
          </div>
        )}
      </div>
      <div className={cn("min-w-0 flex-1", !noPadding && "p-5 md:p-6", bodyClassName)}>
        {children}
      </div>
    </section>
  );
}
